import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-web-header',
  templateUrl: './web-header.component.html',
  styleUrls: ['./web-header.component.scss']
})
export class WebHeaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
